var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-list"},[(_vm.showImage)?_c('img',{staticClass:"m-b-16",attrs:{"src":require("@/assets/images/empty.png")}}):_vm._e(),_c('p',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }